"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$error, _theme$palette2, _theme$palette2$succe, _theme$palette3, _theme$palette3$warni;

  return {
    availability: {
      fontSize: "0.875rem",
      lineHeight: 1.2
    },
    availabilityError: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$error = _theme$palette.error) === null || _theme$palette$error === void 0 ? void 0 : _theme$palette$error.main
    },
    availabilitySuccess: {
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$succe = _theme$palette2.success) === null || _theme$palette2$succe === void 0 ? void 0 : _theme$palette2$succe.main
    },
    availabilityWarning: {
      color: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$warni = _theme$palette3.warning) === null || _theme$palette3$warni === void 0 ? void 0 : _theme$palette3$warni.main
    }
  };
});
var _default = styles;
exports.default = _default;